/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-29",
    versionChannel: "nightly",
    buildDate: "2024-01-29T00:15:42.399Z",
    commitHash: "f2880975ba9cb16fa3a96c5c0d529cbeac81fe78",
};
